// Sentinel markers the backend wraps around matched terms in `snippet`
// (hawk.core.search.types HIGHLIGHT_START/END). We render the enclosed runs as
// <mark> React text nodes rather than injecting HTML, so document text stays
// escaped (no XSS). Keep in sync with the backend constants.
export const HIGHLIGHT_START = '\uE000';
export const HIGHLIGHT_END = '\uE001';

// Mirror of hawk.core.search.types SearchSort — keep in sync.
// Full-text sort options. `rank` (default) orders the most recent candidates
// by relevance; `recency` orders them newest-first.
export type SearchSort = 'rank' | 'recency';
export const DEFAULT_SORT: SearchSort = 'rank';

export type SearchMode = 'fts' | 'grep';
export const DEFAULT_MODE: SearchMode = 'fts';

// Mirror of hawk.core.search.types EntityType / ContentKind — keep in sync.
export type EntityType =
  | 'eval'
  | 'sample'
  | 'message'
  | 'event'
  | 'score'
  | 'scanner_result'
  | 'message_pool';
export type ContentKind =
  | 'result_value'
  | 'eval_metadata'
  | 'sample_metadata'
  | 'scanned_transcript'
  | 'transcript';

export interface SearchResult {
  entity_type: EntityType;
  entity_pk: string;
  sample_pk: string | null;
  scanner_result_pk: string | null;
  rank: number;
  snippet: string | null;
  content_kind: ContentKind;
  eval_set_id: string | null;
  eval_id: string | null;
  sample_id: string | null;
  // Sample short-UUID (Sample.uuid), for deep-linking via go/sample/<uuid>.
  sample_uuid: string | null;
  epoch: number | null;
  task_name: string | null;
  model: string | null;
  location: string | null;
  // Within-transcript deep-link anchor: event uuid (event hits) or message id
  // (message hits); null for hits with no addressable node.
  transcript_anchor: string | null;
}

export interface SearchResponse {
  items: SearchResult[];
  query: string;
  // Literal search may return an empty page with a continuation cursor.
  next_cursor?: string | null;
}
